const questionbank = [
    {
        "id": 1,
        "question": "কম্পিউটারের মস্তিষ্ক কী বলা হয়?",
        "answers": [
            "র‍্যাম",
            "সিপিইউ",
            "হার্ড ড্রাইভ",
            "মনিটর"
        ],
        "correctIndex": 1
    },
    {
        "id": 2,
        "question": "স্ক্রিনে নির্দেশ করতে কোন ডিভাইস ব্যবহৃত হয়?",
        "answers": [
            "কীবোর্ড",
            "প্রিন্টার",
            "মাউস",
            "স্পিকার"
        ],
        "correctIndex": 2
    },
    {
        "id": 3,
        "question": "ওয়েবসাইট ঠিকানায় 'www' এর পূর্ণরূপ কী?",
        "answers": [
            "ওয়ার্ল্ড ওয়াইড ওয়েব",
            "ওয়ার্ল্ড ওয়াইড ওয়েট",
            "ওয়াইড ওয়ার্ল্ড ওয়েব",
            "ওয়েব ওয়ার্ল্ড ওয়াইড"
        ],
        "correctIndex": 0
    },
    {
        "id": 4,
        "question": "বাম দিকের অক্ষর মুছে ফেলতে কোন কী ব্যবহৃত হয়?",
        "answers": [
            "এন্টার",
            "শিফট",
            "ব্যাকস্পেস",
            "স্পেস"
        ],
        "correctIndex": 2
    },
    {
        "id": 5,
        "question": "কম্পিউটারের প্রধান স্ক্রিনকে কী বলা হয়?",
        "answers": [
            "ডেস্কটপ",
            "ল্যাপটপ",
            "ট্যাবলেট",
            "ফোন"
        ],
        "correctIndex": 0
    },
    {
        "id": 6,
        "question": "ওয়েবসাইট ব্রাউজ করতে কোন প্রোগ্রাম ব্যবহৃত হয়?",
        "answers": [
            "ক্যালকুলেটর",
            "ব্রাউজার",
            "পেইন্ট",
            "নোটপ্যাড"
        ],
        "correctIndex": 1
    },
    {
        "id": 7,
        "question": "'USB' এর পূর্ণরূপ কী?",
        "answers": [
            "ইউনিভার্সাল সিরিয়াল বাস",
            "ইউনিক সিস্টেম বোর্ড",
            "ইউজার স্টোরেজ ব্যাংক",
            "আল্ট্রা স্পিড বাফার"
        ],
        "correctIndex": 0
    },
    {
        "id": 8,
        "question": "সব অক্ষর বড় করতে কোন কী ব্যবহৃত হয়?",
        "answers": [
            "Ctrl",
            "Alt",
            "Shift",
            "Tab"
        ],
        "correctIndex": 2
    },
    {
        "id": 9,
        "question": "কম্পিউটারের অস্থায়ী মেমরি কী বলা হয়?",
        "answers": [
            "ROM",
            "RAM",
            "HDD",
            "SSD"
        ],
        "correctIndex": 1
    },
    {
        "id": 10,
        "question": "ছবি ও লেখা দেখাতে কোন ডিভাইস ব্যবহৃত হয়?",
        "answers": [
            "কীবোর্ড",
            "মাউস",
            "মনিটর",
            "প্রিন্টার"
        ],
        "correctIndex": 2
    },
    {
        "id": 11,
        "question": "'CPU' এর পূর্ণরূপ কী?",
        "answers": [
            "কম্পিউটার প্রসেসিং ইউনিট",
            "সেন্ট্রাল প্রোগ্রাম ইউনিট",
            "সেন্ট্রাল প্রসেসিং ইউনিট",
            "কম্পিউটার প্রোগ্রাম ইউনিট"
        ],
        "correctIndex": 2
    },
    {
        "id": 12,
        "question": "টাইপিংয়ে নতুন লাইন তৈরি করতে কোন কী ব্যবহৃত হয়?",
        "answers": [
            "স্পেস",
            "এন্টার",
            "ডিলিট",
            "Esc"
        ],
        "correctIndex": 1
    },
    {
        "id": 13,
        "question": "কম্পিউটার প্রোগ্রামকে কী বলা হয়?",
        "answers": [
            "হার্ডওয়্যার",
            "সফটওয়্যার",
            "ফার্মওয়্যার",
            "ওয়েটওয়্যার"
        ],
        "correctIndex": 1
    },
    {
        "id": 14,
        "question": "ডকুমেন্ট প্রিন্ট করতে কোন ডিভাইস ব্যবহৃত হয়?",
        "answers": [
            "স্ক্যানার",
            "প্রিন্টার",
            "স্পিকার",
            "ওয়েবক্যাম"
        ],
        "correctIndex": 1
    },
    {
        "id": 15,
        "question": "'OS' এর পূর্ণরূপ কী?",
        "answers": [
            "ওপেন সোর্স",
            "অপারেটিং সিস্টেম",
            "অফিস স্যুট",
            "অপটিক্যাল স্টোরেজ"
        ],
        "correctIndex": 1
    },
    {
        "id": 16,
        "question": "ফর্ম ফিল্ডের মধ্যে স্থানান্তরিত হতে কোন কী ব্যবহৃত হয়?",
        "answers": [
            "Ctrl",
            "Alt",
            "Tab",
            "Shift"
        ],
        "correctIndex": 2
    },
    {
        "id": 17,
        "question": "কম্পিউটারের প্রধান স্টোরেজ ডিভাইস কী?",
        "answers": [
            "RAM",
            "CPU",
            "হার্ড ড্রাইভ",
            "মাদারবোর্ড"
        ],
        "correctIndex": 2
    },
    {
        "id": 18,
        "question": "শব্দ শুনতে কোন ডিভাইস ব্যবহৃত হয়?",
        "answers": [
            "মাইক্রোফোন",
            "হেডফোন",
            "মনিটর",
            "কীবোর্ড"
        ],
        "correctIndex": 1
    },
    {
        "id": 19,
        "question": "কম্পিউটারের শারীরিক অংশকে কী বলা হয়?",
        "answers": [
            "সফটওয়্যার",
            "হার্ডওয়্যার",
            "ফার্মওয়্যার",
            "শেয়ারওয়্যার"
        ],
        "correctIndex": 1
    },
    {
        "id": 20,
        "question": "কোনো অপারেশন বাতিল করতে কোন কী ব্যবহৃত হয়?",
        "answers": [
            "এন্টার",
            "Esc",
            "F1",
            "ডিলিট"
        ],
        "correctIndex": 1
    },
    {
        "id": 21,
        "question": "ডেস্কটপের ছোট ছবিকে কী বলা হয়?",
        "answers": [
            "ফোল্ডার",
            "আইকন",
            "উইন্ডো",
            "ফাইল"
        ],
        "correctIndex": 1
    },
    {
        "id": 22,
        "question": "কম্পিউটারে কথা বলতে কোন ডিভাইস ব্যবহৃত হয়?",
        "answers": [
            "স্পিকার",
            "মাইক্রোফোন",
            "ওয়েবক্যাম",
            "প্রিন্টার"
        ],
        "correctIndex": 1
    },
    {
        "id": 23,
        "question": "'GUI' এর পূর্ণরূপ কী?",
        "answers": [
            "জেনারেল ইউজার ইন্টারফেস",
            "গ্রাফিক্যাল ইউজার ইন্টারফেস",
            "গ্রেট ইউনিভার্সাল ইন্টারফেস",
            "গ্লোবাল ইউজার ইন্টারঅ্যাকশন"
        ],
        "correctIndex": 1
    },
    {
        "id": 24,
        "question": "নির্বাচিত টেক্সট কপি করতে কোন কী ব্যবহৃত হয়?",
        "answers": [
            "Ctrl + C",
            "Ctrl + V",
            "Ctrl + X",
            "Ctrl + Z"
        ],
        "correctIndex": 0
    },
    {
        "id": 25,
        "question": "প্রধান সার্কিট বোর্ডকে কী বলা হয়?",
        "answers": [
            "CPU",
            "RAM",
            "মাদারবোর্ড",
            "হার্ড ড্রাইভ"
        ],
        "correctIndex": 2
    },
    {
        "id": 26,
        "question": "কপি করা টেক্সট পেস্ট করতে কোন কী ব্যবহৃত হয়?",
        "answers": [
            "Ctrl + C",
            "Ctrl + V",
            "Ctrl + X",
            "Ctrl + Z"
        ],
        "correctIndex": 1
    },
    {
        "id": 27,
        "question": "কম্পিউটারের দীর্ঘমেয়াদী মেমরি কী বলা হয়?",
        "answers": [
            "RAM",
            "ROM",
            "ক্যাশ",
            "বাফার"
        ],
        "correctIndex": 1
    },
    {
        "id": 28,
        "question": "ছবি স্ক্যান করতে কোন ডিভাইস ব্যবহৃত হয়?",
        "answers": [
            "প্রিন্টার",
            "স্ক্যানার",
            "ওয়েবক্যাম",
            "মাইক্রোফোন"
        ],
        "correctIndex": 1
    },
    {
        "id": 29,
        "question": "'URL' এর পূর্ণরূপ কী?",
        "answers": [
            "ইউনিভার্সাল রিসোর্স লোকেটর",
            "ইউনিফর্ম রিসোর্স লোকেটর",
            "ইউনিক রিসোর্স লিংক",
            "ইউনাইটেড রেফারেন্স লিংক"
        ],
        "correctIndex": 1
    },
    {
        "id": 30,
        "question": "নির্বাচিত টেক্সট কাট করতে কোন কী ব্যবহৃত হয়?",
        "answers": [
            "Ctrl + C",
            "Ctrl + V",
            "Ctrl + X",
            "Ctrl + Z"
        ],
        "correctIndex": 2
    },
    {
        "id": 31,
        "question": "ফাইলের সংগ্রহকে কী বলা হয়?",
        "answers": [
            "আইকন",
            "ফোল্ডার",
            "প্রোগ্রাম",
            "ডকুমেন্ট"
        ],
        "correctIndex": 1
    },
    {
        "id": 32,
        "question": "অনলাইনে অন্যদের দেখতে কোন ডিভাইস ব্যবহৃত হয়?",
        "answers": [
            "মাইক্রোফোন",
            "স্পিকার",
            "ওয়েবক্যাম",
            "প্রিন্টার"
        ],
        "correctIndex": 2
    },
    {
        "id": 33,
        "question": "'ISP' এর পূর্ণরূপ কী?",
        "answers": [
            "ইন্টারনেট সার্ভিস প্রোভাইডার",
            "ইন্টারন্যাশনাল সিস্টেম প্রোটোকল",
            "ইন্টিগ্রেটেড সার্ভিস প্ল্যাটফর্ম",
            "ইন্টারনেট সিকিউরিটি প্রোগ্রাম"
        ],
        "correctIndex": 0
    },
    {
        "id": 34,
        "question": "কোনো কাজ আনডু করতে কোন কী ব্যবহৃত হয়?",
        "answers": [
            "Ctrl + C",
            "Ctrl + V",
            "Ctrl + X",
            "Ctrl + Z"
        ],
        "correctIndex": 3
    },
    {
        "id": 35,
        "question": "কম্পিউটারের নির্দেশাবলীকে কী বলা হয়?",
        "answers": [
            "ডেটা",
            "প্রোগ্রাম",
            "ফাইল",
            "ফোল্ডার"
        ],
        "correctIndex": 1
    },
    {
        "id": 36,
        "question": "ইন্টারনেটে সংযুক্ত করতে কোন ডিভাইস ব্যবহৃত হয়?",
        "answers": [
            "রাউটার",
            "মনিটর",
            "কীবোর্ড",
            "মাউস"
        ],
        "correctIndex": 0
    },
    {
        "id": 37,
        "question": "'HTML' এর পূর্ণরূপ কী?",
        "answers": [
            "হাইপার টেক্সট মার্কআপ ল্যাঙ্গুয়েজ",
            "হাই টেক মডার্ন ল্যাঙ্গুয়েজ",
            "হোম টুল মার্কআপ ল্যাঙ্গুয়েজ",
            "হাইপারলিংক অ্যান্ড টেক্সট মার্কআপ ল্যাঙ্গুয়েজ"
        ],
        "correctIndex": 0
    },
    {
        "id": 38,
        "question": "সব টেক্সট নির্বাচন করতে কোন কী ব্যবহৃত হয়?",
        "answers": [
            "Ctrl + A",
            "Ctrl + S",
            "Ctrl + P",
            "Ctrl + F"
        ],
        "correctIndex": 0
    },
    {
        "id": 39,
        "question": "কম্পিউটারের কাজের এলাকাকে কী বলা হয়?",
        "answers": [
            "ডেস্কটপ",
            "ল্যাপটপ",
            "ট্যাবলেট",
            "ফোন"
        ],
        "correctIndex": 0
    },
    {
        "id": 40,
        "question": "ডেটা স্থায়ীভাবে সংরক্ষণ করতে কোন ডিভাইস ব্যবহৃত হয়?",
        "answers": [
            "RAM",
            "CPU",
            "SSD",
            "ক্যাশ"
        ],
        "correctIndex": 2
    },
    {
        "id": 41,
        "question": "'PDF' এর পূর্ণরূপ কী?",
        "answers": [
            "পোর্টেবল ডকুমেন্ট ফরম্যাট",
            "পাবলিক ডেটা ফাইল",
            "প্রিন্টেবল ডকুমেন্ট ফর্ম",
            "পার্সোনাল ডেটা ফরম্যাট"
        ],
        "correctIndex": 0
    },
    {
        "id": 42,
        "question": "ডকুমেন্ট সেভ করতে কোন কী ব্যবহৃত হয়?",
        "answers": [
            "Ctrl + A",
            "Ctrl + S",
            "Ctrl + P",
            "Ctrl + F"
        ],
        "correctIndex": 1
    },
    {
        "id": 43,
        "question": "বহনযোগ্য ছোট কম্পিউটারকে কী বলা হয়?",
        "answers": [
            "ডেস্কটপ",
            "ল্যাপটপ",
            "সার্ভার",
            "মেইনফ্রেম"
        ],
        "correctIndex": 1
    },
    {
        "id": 44,
        "question": "টাইপ করতে কোন ডিভাইস ব্যবহৃত হয়?",
        "answers": [
            "মাউস",
            "কীবোর্ড",
            "মনিটর",
            "প্রিন্টার"
        ],
        "correctIndex": 1
    },
    {
        "id": 45,
        "question": "'Wi-Fi' এর পূর্ণরূপ কী?",
        "answers": [
            "ওয়্যারলেস ফিডেলিটি",
            "ওয়্যারড ইন্টারনেট",
            "ওয়াইড ফ্রিকোয়েন্সি",
            "ওয়ার্ল্ডওয়াইড ইন্টারনেট"
        ],
        "correctIndex": 0
    },
    {
        "id": 46,
        "question": "ডকুমেন্ট প্রিন্ট করতে কোন কী ব্যবহৃত হয়?",
        "answers": [
            "Ctrl + A",
            "Ctrl + S",
            "Ctrl + P",
            "Ctrl + F"
        ],
        "correctIndex": 2
    },
    {
        "id": 47,
        "question": "কম্পিউটারের ভিজ্যুয়াল আউটপুট কী?",
        "answers": [
            "কীবোর্ড",
            "মাউস",
            "মনিটর",
            "স্পিকার"
        ],
        "correctIndex": 2
    },
    {
        "id": 48,
        "question": "ওয়্যারলেসভাবে ইন্টারনেটে সংযুক্ত করতে কোন ডিভাইস ব্যবহৃত হয়?",
        "answers": [
            "ইথারনেট কেবল",
            "ওয়াই-ফাই রাউটার",
            "USB ড্রাইভ",
            "পাওয়ার কেবল"
        ],
        "correctIndex": 1
    },
    {
        "id": 49,
        "question": "'SSD' এর পূর্ণরূপ কী?",
        "answers": [
            "সলিড স্টেট ড্রাইভ",
            "সুপার স্পিড ডিস্ক",
            "সিস্টেম স্টোরেজ ডিভাইস",
            "সিকিউর স্টোরেজ ড্রাইভ"
        ],
        "correctIndex": 0
    },
    {
        "id": 50,
        "question": "ডকুমেন্টে টেক্সট খুঁজতে কোন কী ব্যবহৃত হয়?",
        "answers": [
            "Ctrl + A",
            "Ctrl + S",
            "Ctrl + P",
            "Ctrl + F"
        ],
        "correctIndex": 3
    },
    {
        "id": 51,
        "question": "কম্পিউটারের পয়েন্টিং ডিভাইস কী?",
        "answers": [
            "কীবোর্ড",
            "মাউস",
            "মনিটর",
            "প্রিন্টার"
        ],
        "correctIndex": 1
    },
    {
        "id": 52,
        "question": "কম্পিউটারে আঁকতে কোন ডিভাইস ব্যবহৃত হয়?",
        "answers": [
            "মাউস",
            "কীবোর্ড",
            "গ্রাফিক্স ট্যাবলেট",
            "মাইক্রোফোন"
        ],
        "correctIndex": 2
    },
    {
        "id": 53,
        "question": "'JPEG' এর পূর্ণরূপ কী?",
        "answers": [
            "জয়েন্ট ফটোগ্রাফিক এক্সপার্টস গ্রুপ",
            "জাম্বো পিকচার এক্সটেনশন",
            "জয়েন্ট পিকচার এনকোডিং গ্রুপ",
            "জেপেগ ফটো এক্সটেনশন"
        ],
        "correctIndex": 0
    },
    {
        "id": 54,
        "question": "ওয়েবপেজ রিফ্রেশ করতে কোন কী ব্যবহৃত হয়?",
        "answers": [
            "F1",
            "F5",
            "F10",
            "F12"
        ],
        "correctIndex": 1
    },
    {
        "id": 55,
        "question": "কম্পিউটারের প্রধান স্টোরেজ কী?",
        "answers": [
            "RAM",
            "CPU",
            "হার্ড ড্রাইভ",
            "ক্যাশ"
        ],
        "correctIndex": 2
    },
    {
        "id": 56,
        "question": "গেম নিয়ন্ত্রণ করতে কোন ডিভাইস ব্যবহৃত হয়?",
        "answers": [
            "কীবোর্ড",
            "গেম কন্ট্রোলার",
            "মাউস",
            "মনিটর"
        ],
        "correctIndex": 1
    },
    {
        "id": 57,
        "question": "'AI' এর পূর্ণরূপ কী?",
        "answers": [
            "অটোমেটেড ইন্টেলিজেন্স",
            "আর্টিফিশিয়াল ইন্টেলিজেন্স",
            "অ্যাডভান্সড ইন্টারঅ্যাকশন",
            "অটোমেটিক ইন্টারফেস"
        ],
        "correctIndex": 1
    },
    {
        "id": 58,
        "question": "হেল্প খুলতে কোন কী ব্যবহৃত হয়?",
        "answers": [
            "F1",
            "F5",
            "F10",
            "F12"
        ],
        "correctIndex": 0
    },
    {
        "id": 59,
        "question": "কম্পিউটারের অস্থায়ী স্টোরেজ কী?",
        "answers": [
            "ROM",
            "RAM",
            "HDD",
            "SSD"
        ],
        "correctIndex": 1
    },
    {
        "id": 60,
        "question": "ডিজিটাল ছবি তুলতে কোন ডিভাইস ব্যবহৃত হয়?",
        "answers": [
            "ওয়েবক্যাম",
            "ডিজিটাল ক্যামেরা",
            "স্ক্যানার",
            "মাইক্রোফোন"
        ],
        "correctIndex": 1
    },
    {
        "id": 61,
        "question": "'USB' কী সংযুক্ত করে?",
        "answers": [
            "মনিটর",
            "কীবোর্ড",
            "প্রিন্টার",
            "এই সবকিছু"
        ],
        "correctIndex": 3
    },
    {
        "id": 62,
        "question": "স্টার্ট মেনু খুলতে কোন কী ব্যবহৃত হয়?",
        "answers": [
            "Ctrl",
            "Alt",
            "উইন্ডোজ কী",
            "Shift"
        ],
        "correctIndex": 2
    },
    {
        "id": 63,
        "question": "কম্পিউটারের ইনপুট ডিভাইস কী?",
        "answers": [
            "মনিটর",
            "স্পিকার",
            "কীবোর্ড",
            "প্রিন্টার"
        ],
        "correctIndex": 2
    },
    {
        "id": 64,
        "question": "ভিডিও কল করতে কোন ডিভাইস ব্যবহৃত হয়?",
        "answers": [
            "মাইক্রোফোন",
            "ওয়েবক্যাম",
            "স্পিকার",
            "মনিটর"
        ],
        "correctIndex": 1
    },
    {
        "id": 65,
        "question": "'OS' কী পরিচালনা করে?",
        "answers": [
            "হার্ডওয়্যার",
            "সফটওয়্যার",
            "উভয়ই",
            "কোনোটিই নয়"
        ],
        "correctIndex": 2
    },
    {
        "id": 66,
        "question": "খোলা উইন্ডোর মধ্যে স্যুইচ করতে কোন কী ব্যবহৃত হয়?",
        "answers": [
            "Alt + Tab",
            "Ctrl + Tab",
            "Shift + Tab",
            "উইন্ডোজ + Tab"
        ],
        "correctIndex": 0
    },
    {
        "id": 67,
        "question": "কম্পিউটারের আউটপুট ডিভাইস কী?",
        "answers": [
            "কীবোর্ড",
            "মাউস",
            "মনিটর",
            "মাইক্রোফোন"
        ],
        "correctIndex": 2
    },
    {
        "id": 68,
        "question": "ফাইল সংরক্ষণ করতে কোন ডিভাইস ব্যবহৃত হয়?",
        "answers": [
            "USB ড্রাইভ",
            "মনিটর",
            "স্পিকার",
            "মাউস"
        ],
        "correctIndex": 0
    },
    {
        "id": 69,
        "question": "'HTTP' এর পূর্ণরূপ কী?",
        "answers": [
            "হাইপারটেক্সট ট্রান্সফার প্রোটোকল",
            "হাই টেক ট্রান্সফার প্রোটোকল",
            "হোম টুল ট্রান্সফার প্রোটোকল",
            "হাইপারলিংক টেক্সট ট্রান্সফার প্রোটোকল"
        ],
        "correctIndex": 0
    },
    {
        "id": 70,
        "question": "উইন্ডো বন্ধ করতে কোন কী ব্যবহৃত হয়?",
        "answers": [
            "Alt + F4",
            "Ctrl + F4",
            "Shift + F4",
            "F4"
        ],
        "correctIndex": 0
    },
    {
        "id": 71,
        "question": "কম্পিউটারের মেমরি চিপ কী?",
        "answers": [
            "CPU",
            "RAM",
            "HDD",
            "SSD"
        ],
        "correctIndex": 1
    },
    {
        "id": 72,
        "question": "সঙ্গীত শুনতে কোন ডিভাইস ব্যবহৃত হয়?",
        "answers": [
            "মাইক্রোফোন",
            "হেডফোন",
            "ওয়েবক্যাম",
            "প্রিন্টার"
        ],
        "correctIndex": 1
    },
    {
        "id": 73,
        "question": "'IP' এর পূর্ণরূপ কী?",
        "answers": [
            "ইন্টারনেট প্রোটোকল",
            "ইন্টারন্যাশনাল প্রোভাইডার",
            "ইন্টারনাল প্রসেস",
            "ইনপুট পোর্ট"
        ],
        "correctIndex": 0
    },
    {
        "id": 74,
        "question": "কম্পিউটার লক করতে কোন কী ব্যবহৃত হয়?",
        "answers": [
            "উইন্ডোজ + L",
            "Ctrl + L",
            "Alt + L",
            "Shift + L"
        ],
        "correctIndex": 0
    },
    {
        "id": 75,
        "question": "কম্পিউটারের প্রসেসিং ইউনিট কী?",
        "answers": [
            "RAM",
            "CPU",
            "HDD",
            "SSD"
        ],
        "correctIndex": 1
    },
    {
        "id": 76,
        "question": "ইন্টারনেটে সংযুক্ত করতে কোন ডিভাইস ব্যবহৃত হয়?",
        "answers": [
            "মডেম",
            "মনিটর",
            "কীবোর্ড",
            "মাউস"
        ],
        "correctIndex": 0
    },
    {
        "id": 77,
        "question": "'WWW' কী করতে সাহায্য করে?",
        "answers": [
            "ডকুমেন্ট টাইপ করা",
            "ওয়েবসাইট ব্রাউজ করা",
            "গেম খেলা",
            "ছবি আঁকা"
        ],
        "correctIndex": 1
    },
    {
        "id": 78,
        "question": "স্ক্রিনশট নিতে কোন কী ব্যবহৃত হয়?",
        "answers": [
            "প্রিন্ট স্ক্রিন",
            "স্ক্রল লক",
            "পজ",
            "ইনসার্ট"
        ],
        "correctIndex": 0
    },
    {
        "id": 79,
        "question": "কম্পিউটারের স্টোরেজ ডিভাইস কী?",
        "answers": [
            "CPU",
            "RAM",
            "হার্ড ড্রাইভ",
            "মাদারবোর্ড"
        ],
        "correctIndex": 2
    },
    {
        "id": 80,
        "question": "ছবি প্রিন্ট করতে কোন ডিভাইস ব্যবহৃত হয়?",
        "answers": [
            "স্ক্যানার",
            "প্রিন্টার",
            "ওয়েবক্যাম",
            "মাইক্রোফোন"
        ],
        "correctIndex": 1
    },
    {
        "id": 81,
        "question": "'URL' কী চিহ্নিত করে?",
        "answers": [
            "একটি কম্পিউটার",
            "একটি ওয়েবসাইট",
            "একটি প্রোগ্রাম",
            "একটি ফাইল"
        ],
        "correctIndex": 1
    },
    {
        "id": 82,
        "question": "টাস্ক ম্যানেজার খুলতে কোন কী ব্যবহৃত হয়?",
        "answers": [
            "Ctrl + Shift + Esc",
            "Ctrl + Alt + Del",
            "Alt + Tab",
            "উইন্ডোজ + R"
        ],
        "correctIndex": 0
    },
    {
        "id": 83,
        "question": "কম্পিউটারের ইনপুট/আউটপুট ডিভাইস কী?",
        "answers": [
            "মনিটর",
            "টাচস্ক্রিন",
            "স্পিকার",
            "প্রিন্টার"
        ],
        "correctIndex": 1
    },
    {
        "id": 84,
        "question": "ডকুমেন্ট স্ক্যান করতে কোন ডিভাইস ব্যবহৃত হয়?",
        "answers": [
            "প্রিন্টার",
            "স্ক্যানার",
            "ওয়েবক্যাম",
            "মাইক্রোফোন"
        ],
        "correctIndex": 1
    },
    {
        "id": 85,
        "question": "'ISP' কী প্রদান করে?",
        "answers": [
            "সফটওয়্যার",
            "হার্ডওয়্যার",
            "ইন্টারনেট অ্যাক্সেস",
            "বিদ্যুৎ"
        ],
        "correctIndex": 2
    },
    {
        "id": 86,
        "question": "উইন্ডো মিনিমাইজ করতে কোন কী ব্যবহৃত হয়?",
        "answers": [
            "উইন্ডোজ + ডাউন অ্যারো",
            "উইন্ডোজ + M",
            "Alt + Space + N",
            "এই সবকিছু"
        ],
        "correctIndex": 3
    },
    {
        "id": 87,
        "question": "কম্পিউটারের এক্সপানশন কার্ড কী?",
        "answers": [
            "RAM",
            "CPU",
            "গ্রাফিক্স কার্ড",
            "হার্ড ড্রাইভ"
        ],
        "correctIndex": 2
    },
    {
        "id": 88,
        "question": "অডিও বাজাতে কোন ডিভাইস ব্যবহৃত হয়?",
        "answers": [
            "মাইক্রোফোন",
            "স্পিকার",
            "ওয়েবক্যাম",
            "প্রিন্টার"
        ],
        "correctIndex": 1
    },
    {
        "id": 89,
        "question": "'GUI' কী ব্যবহার করে?",
        "answers": [
            "শুধু টেক্সট",
            "আইকন এবং উইন্ডো",
            "শুধু কমান্ড",
            "শুধু সংখ্যা"
        ],
        "correctIndex": 1
    },
    {
        "id": 90,
        "question": "রান ডায়ালগ খুলতে কোন কী ব্যবহৃত হয়?",
        "answers": [
            "উইন্ডোজ + R",
            "Ctrl + R",
            "Alt + R",
            "Shift + R"
        ],
        "correctIndex": 0
    },
    {
        "id": 91,
        "question": "কম্পিউটারের পোর্টেবল স্টোরেজ কী?",
        "answers": [
            "RAM",
            "CPU",
            "USB ড্রাইভ",
            "মাদারবোর্ড"
        ],
        "correctIndex": 2
    },
    {
        "id": 92,
        "question": "হ্যান্ডরাইটিং ইনপুট করতে কোন ডিভাইস ব্যবহৃত হয়?",
        "answers": [
            "মাউস",
            "কীবোর্ড",
            "গ্রাফিক্স ট্যাবলেট",
            "মাইক্রোফোন"
        ],
        "correctIndex": 2
    },
    {
        "id": 93,
        "question": "'HTML' কী তৈরি করে?",
        "answers": [
            "স্প্রেডশীট",
            "ওয়েবপেজ",
            "ডকুমেন্ট",
            "প্রেজেন্টেশন"
        ],
        "correctIndex": 1
    },
    {
        "id": 94,
        "question": "উইন্ডো ম্যাক্সিমাইজ করতে কোন কী ব্যবহৃত হয়?",
        "answers": [
            "উইন্ডোজ + আপ অ্যারো",
            "উইন্ডোজ + X",
            "Alt + Space + X",
            "এই সবকিছু"
        ],
        "correctIndex": 3
    },
    {
        "id": 95,
        "question": "কম্পিউটারের অপটিক্যাল ড্রাইভ কী?",
        "answers": [
            "RAM",
            "CPU",
            "DVD ড্রাইভ",
            "হার্ড ড্রাইভ"
        ],
        "correctIndex": 2
    },
    {
        "id": 96,
        "question": "ভয়েস ইনপুট করতে কোন ডিভাইস ব্যবহৃত হয়?",
        "answers": [
            "স্পিকার",
            "মাইক্রোফোন",
            "ওয়েবক্যাম",
            "প্রিন্টার"
        ],
        "correctIndex": 1
    },
    {
        "id": 97,
        "question": "'PDF' কী সংরক্ষণ করে?",
        "answers": [
            "ফরম্যাটিং",
            "শব্দ",
            "ভিডিও",
            "গেম"
        ],
        "correctIndex": 0
    },
    {
        "id": 98,
        "question": "কন্ট্রোল প্যানেল খুলতে কোন কী ব্যবহৃত হয়?",
        "answers": [
            "উইন্ডোজ + X",
            "উইন্ডোজ + I",
            "উইন্ডোজ + R",
            "উইন্ডোজ + পজ"
        ],
        "correctIndex": 1
    },
    {
        "id": 99,
        "question": "কম্পিউটারের নেটওয়ার্ক কার্ড কী?",
        "answers": [
            "RAM",
            "CPU",
            "ইথারনেট কার্ড",
            "হার্ড ড্রাইভ"
        ],
        "correctIndex": 2
    },
    {
        "id": 100,
        "question": "ওয়্যারলেসভাবে সংযুক্ত হতে কোন ডিভাইস ব্যবহৃত হয়?",
        "answers": [
            "ইথারনেট কেবল",
            "ওয়াই-ফাই অ্যাডাপ্টার",
            "USB কেবল",
            "পাওয়ার কেবল"
        ],
        "correctIndex": 1
    }
]

// export default questionbank

const quizSession = (n = 10) => {
    return Promise.resolve(questionbank.sort(() => 0.5 - Math.random()).slice(0, n))
}

export default quizSession
